export const TERRAIN_TYPES_POPULATED = 'TERRAIN_TYPES_POPULATED';
export const TERRAIN_TYPES_ADDED = 'TERRAIN_TYPES_ADDED';

export const BORDER_TYPES_SET = 'BORDER_TYPES_SET';

export const HEIGHT_CATEGORIES_SET = 'HEIGHT_CATEGORIES_SET';

export const QUADS_SET = 'QUADS_SET';

export const DELETE_FILTERED_SYSTEMS = 'DELETE_FILTERED_SYSTEMS';

export const SIDES_POPULATED = 'SIDES_POPULATED';
export const SIDE_RELATIONS_POPULATED = 'SIDE_RELATIONS_POPULATED';
export const AGENTS_POPULATED = 'AGENTS_POPULATED';
export const FACTIONS_POPULATED = 'FACTIONS_POPULATED';
export const PROTOTYPES_POPULATED = 'PROTOTYPES_POPULATED';
export const PROTOTYPES_REMOVED = 'PROTOTYPES_REMOVED';
export const SYSTEMS_POPULATED = 'SYSTEMS_POPULATED';
export const AMMO_INDEXES_POPULATED = 'AMMO_INDEXES_POPULATED';
export const SUPPLIES_POPULATED = 'SUPPLIES_POPULATED';
export const AMMUNITIONS_POPULATED = 'AMMUNITIONS_POPULATED';
export const SET_ACTIVE_SIDES = 'SET_ACTIVE_SIDES';

export const AIRCRAFTS_POPULATED = 'AIRCRAFTS_POPULATED';
export const NAVALCRAFTS_POPULATED = 'NAVALCRAFTS_POPULATED';
export const OBSTACLES_POPULATED = 'OBSTACLES_POPULATED';
export const COMM_DEVICES_POPULATED = 'COMM_DEVICES_POPULATED';

export const SET_COMMANDS = 'SET_COMMANDS';
export const SET_COMMAND_GROUPS = 'SET_COMMAND_GROUPS';
export const ADD_COMMAND = 'ADD_COMMAND';
export const EDIT_COMMAND = 'EDIT_COMMAND';
export const DELETE_COMMANDS = 'DELETE_COMMANDS';

export const ADD_COMMAND_RESULT = 'ADD_COMMAND_RESULT';

export const SET_EDITED_COMMANDS = 'SET_EDITED_COMMANDS';
export const DELETED_COMMANS_IN_EDITED_COMMANDS = 'DELETED_COMMANS_IN_EDITED_COMMANDS';
export const RESET_DELETED_COMMANDS_IN_EDITED_COMMANDS = 'RESET_DELETED_COMMANDS_IN_EDITED_COMMANDS';

export const SET_COMAOS = 'SET_COMAOS';
export const ADD_COMAO = 'ADD_COMAO';
export const EDIT_COMAO = 'EDIT_COMAO';
export const DELETE_COMAO = 'DELETE_COMAO';

export const SET_HAVA_2D_DATA = 'SET_HAVA_2D_DATA';

export const HYMOTS_DB_CHANGED = 'HYMOTS_DB_CHANGED';
export const SET_SELECTED_ETMEN = 'SET_SELECTED_ETMEN';
export const DELETE_NODES = 'DELETE_NODES';
export const ADD_NODE = 'ADD_NODE';
